/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TimePicker/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import Time from 'DesignSystem/Time/index'
import ViewsStream from 'Simple/Stream/react-dom'
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function TimePicker({
  children,
  viewPath = "/DesignSystem/TimePicker",
  from,
  onClick,
  isSelected,
  parentViewPath
  
}) {
  return (<React.Fragment
>
<div
  data-testid="TimePicker.Vertical"
  data-view-path={viewPath}
 className={`views-block fixedScroll`}
>
<div
  data-testid="TimePicker.List"
  data-view-path={viewPath}
 className={`views-block ${styles.List}`}
>
<ViewsStream
>
{Array.isArray(from) && from.map((item, index, list) => 
<ListItem
        key={item?.id ?? item?._id ?? index}
        context="time"
        item={item}
        index={index}
        list={list}
        hasItemKey={false}
        parentViewPath={viewPath}
        viewPath={`${viewPath}/Time(${item?.id ?? item?._id ?? index})`}
      >
<Time
 index={index} indexReverse={list.length - index} isFirst={index === 0} isLast={index === list.length - 1}
 item={item}
 viewPath={`${viewPath}/Time(${item?.id ?? item?._id ?? index})`}
 onClick={onClick}
 isSelected={isSelected}
 parentViewPath={parentViewPath}
/>
</ListItem>
)}
</ViewsStream>
</div>
</div>
{children}
</React.Fragment>)
}

  function ListItem(props) {
    let valueItem = React.useMemo(() => ({
      index: props.index,
      indexReverse: props.list.length - props.index,
      isFirst: props.index === 0,
      isLast: props.index === props.list.length - 1,
    }), [props.index, props.list])
    
    
    
    return (
      <fromData.DataProvider
      context={props.context}
      value={props.item}
      
      
      viewPath={props.viewPath}
    >
      <fromData.DataProvider
        context={`${props.context}_item`}
        value={valueItem}
        viewPath={props.viewPath}
      >
        {props.children}
      </fromData.DataProvider>
    </fromData.DataProvider>
    )
  }